import { render, staticRenderFns } from "./TableOpenFundraisingNeeds.vue?vue&type=template&id=730d8b6f"
import script from "./TableOpenFundraisingNeeds.vue?vue&type=script&lang=js"
export * from "./TableOpenFundraisingNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports